import { createContext } from "react";
import { IReminderContext } from "./models/IReminderContextt";

export const ReminderContext = createContext<IReminderContext>({
    isVisible: false,
    reminder: null,
    showReminder: () => {},
    closeReminder: () => {},
})